import React from 'react'
import { PagingSidePanelType, Box as Section, SidePanel } from '@node-space/ui-components'
import { appBannersId } from 'components/app/AppBanners'
import { useComponentHeight } from 'hooks/useComponentHeight'
import { PendingTransactionsResponse } from 'types/approvals'
import { highlightRowBasedOnId } from 'utils/table/table'
import { SidePanelBody } from './SidePanelBody'
import { SidePanelHeaderTemplate } from './SidePanelHeaderTemplate'

interface SidePanelSummaryProps {
  isOpen: boolean
  paging: PagingSidePanelType
  onClose: () => void
  transactionDetails: PendingTransactionsResponse
  tab?: string
}

export const SidePanelSummary = ({
  isOpen,
  paging,
  onClose,
  transactionDetails,
  tab,
}: SidePanelSummaryProps) => {
  const bannerSpacing = useComponentHeight(appBannersId)

  return (
    <SidePanel
      id="side-panel-summary"
      isOpen={isOpen}
      paging={paging}
      onClose={onClose}
      activeRowId={transactionDetails?.userReference}
      topOffset={bannerSpacing}
      onActiveRowChange={highlightRowBasedOnId}
      header={<SidePanelHeaderTemplate transactionDetails={transactionDetails} />}
      body={
        <Section tag="section" width="full" background="layer-1">
          <SidePanelBody transactionDetails={transactionDetails} tab={tab} />
        </Section>
      }
    />
  )
}
